// extracted by mini-css-extract-plugin
export default {"signInLink":"forgot-password_signInLink__UzA6u"};